// Layout2.js
import React from "react";
import { Outlet } from "react-router-dom";
import Navbar2 from "./Navbar2";
import Footer2 from "../Footer/Footer7";

export default function Layout2() {
  return (
    <>
    <style>{`
    @media (max-width: 768px) {
  .services-content,
  .inner-page {
    margin-top: 0 !important;
  }

  #header {
    margin-bottom: 0 !important;
  }
}
`}</style>
      <header id="header" className="header-top-fixed force-small-header">
        <div className="full-screen-block">
          <div className="header-body header-body-fixed" id="header-body-fixed">
            <div id="container-fixed">
              <Navbar2 forceSmallHeader={true} />
            </div>
          </div>
        </div>
      </header>

      <div className="internal-header-spacer" aria-hidden="true" />

      <div className="services-shell1 no-sidepanel page-with-fixed-header inner-page">
        <main className="services-content">
          <Outlet />
        </main>

        <Footer2></Footer2>
      </div>
    </>
  );
}
